export const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const currencyFormatNoDecimals = (amount) => {
  const currency = currencyFormatter.format(amount);
  return currency.split(".")[0];
}

export const isEmailValid = (email) => {
  if (email === "") return false;
  let re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const numberWithComas = (number) => {
  let tempNumber = number
  if (typeof number === "string") {
    parseInt(tempNumber)
  }
  return tempNumber.toLocaleString()
}

export const removeSpaces = (string) => {
  return string.toString().replace(/\s/g, '')
}

export const isFloat = (x) => { return !!(x % 1); }

export const mergeClientCoClientAge = (coCLient, client) => {
  return `${coCLient}/${client}`
}

export const collectErrorMessages = (validations, type) => {
  let errorMessages = [];
  const commonErrorMessage = "All the inputs highlighted in red to ensure they are valid.";
  if (validations && validations.length > 0) {
    validations.forEach(items => {
      Object.keys(items).forEach((key) => {
        if (key === "needAtLeastOne") {
          errorMessages.push(`At least one ${type} must be saved before calculating the plan.`);
        } else if (key === "contributions") {
          Object.keys(items[key]).forEach((contributionKey) => {
            if (!items[key][contributionKey].valid && !errorMessages.includes(commonErrorMessage)) {
              errorMessages.push(commonErrorMessage);
            }
          });
        } else {
          if (!items[key].valid && !errorMessages.includes(commonErrorMessage)) {
            errorMessages.push(commonErrorMessage);
          }
        }
      });
    });
  }
  return errorMessages;
};

export const formatNumberToPercentage = (number, places) => {
  if (number == null)
    return "";
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places: 0;
  var negative = number < 0 ? "-": "",
      i = parseInt(number = Math.abs( + number || 0).toFixed(places), 10) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
  return negative + (j ? i.substr(0, j) + ",": "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") + (places ? "." + Math.abs(number - i).toFixed(places).slice(2) : "") + "%";
};

export const AppliesToFriendlyNames = {
  "CLIENT": "Client",
  "SPOUSE": "Spouse",
  "CO_CLIENT": "Spouse",
  "JOINT": "Joint",
  "TRUST": "Trust"
};

export const SOURCES = {
  "OUTSIDE_SOURCE": "Outside Source",
  "CURRENT_INCOME": "Current Income",
}

export const INCOME_TYPES = {
  "EXCESS_INCOME" : "Excess Income",
  "CURRENT_INCOME": "Current Income",
}

export const PAYOUT_TYPES = {
  "INCREASING" : "Increasing",
  "LEVEL": "Level",
}

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function isAccountRothConversionIntoFIA(item, accounts) {
  const isSelectedAccountAPreTaxAccount = () => {
    const selectedAccountId = item.accountId;
    const selectedAccount = accounts.find(account => account.id === selectedAccountId);
    return selectedAccount && (selectedAccount.taxType === 'PRE-TAX' || selectedAccount.taxType === 'PRE_TAX');
  }
  return item.annuityType === "VOLATILITY_BUFFER" && (item.taxType === "TAX-FREE" || item.taxType === "TAX_FREE") && isSelectedAccountAPreTaxAccount();
}